<template>
  <div class="mw-panel">
    <div class="mw-panel org_select"></div>
  </div>
</template>

<script>
  export default {
    props: {
      params: {
        type: Object
      }
    },
    data() {
      return {
        $org:undefined
      }
    },
    mounted() {
      let me = this, selectMode;
      let config=me.params.config || {};
      let cfg = config.getConfig && config.getConfig() || {};
      if(undefined === cfg.singleSel && undefined === cfg.multiSelection) {
        selectMode = 2;
      } else if(cfg.singleSel || !cfg.multiSelection) {
        selectMode = 1;
      } else {
        selectMode = 2;
      }
      cfg.selectMode = selectMode;
      me.$nextTick(function () {
        $WR.ready(function (manager) {
          manager.create({
            xtype: 'bm/OrganizationSelection',
            /*dataMode:cfg.dataMode,
            selectMode:selectMode,*/
            $form:config.getForm && config.getForm(),
            $dd: cfg,
            renderTo: $(me.$el.querySelector('.org_select'))
          }, function (x) {
            x.render();
            me.$org=x;
            if(me.params.value){
              me.setValue(me.params.value);
            }
            x.on('showPersonalGroupManager', function (main) {
            });
          });
        });
      })
    },
    methods: {
      getValue(){
        return this.$org.getValue()
      },
      setValue(val){
        return this.$org.setValue(val)
      }
    }
  }
</script>





// WEBPACK FOOTER //
// src/modules/index/components/public-dialog/form/org.vue